let listenList = []
const config = {

}
config.afterInit = (callback)=>{
  listenList.push(callback);
}
config.init = (data)=>{
  for(let key in data){
    if(['init','afterInit'].includes(key)){
      continue;
    }
    config[key] = data[key];
  }
  let func = listenList.shift();
  while(func){
    try{
      func(config)
    }catch(e){}
    func = listenList.shift();
    console.log(func)
  }
}
export default config;
